export default {
    state:{
        routerMenus:[]
    },
    getters: {
        getRouterMenus(state){
            return state.routerMenus
        }
    },
    mutations: {
        SET_ROUTER_MENUS(state,data){
            state.routerMenus = convertRouterMenus(data) 
        }
    }
}
const convertRouterMenus = (data = []) => {
    const menus = data
    return menus
}